// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3la_3","content":"LoadingAlert_content__2Oq7M"};